export default __webpack_public_path__ + "images/low_saturation.7d4e63a.svg";